import Vue from 'vue';
import Router from 'vue-router';
import Index from '../views/Index'
import ProjectList from '../views/projectManage/ProjectList'
import SingleIndex from '../views/projectManage/singleProject/SingleIndex'
import DataManage from '../views/projectManage/singleProject/DataManage'
import DatasetView from '../views/projectManage/singleProject/dataManage/DatasetView'
import VersionView from '../views/projectManage/singleProject/dataManage/VersionView'
import VersionCompare from '../views/projectManage/singleProject/dataManage/VersionCompare'
import BasicInfo from '../views/projectManage/singleProject/BasicInfo'
import ProjManager from '../views/projectManage/singleProject/ProjManager'
import SceneManage from '../views/projectManage/singleProject/sceneManage/SceneManage'
import SceneView from '../views/projectManage/singleProject/sceneManage/sceneView/SceneView'
import AttachmentView from '../views/projectManage/singleProject/sceneManage/sceneView/components/AttachmentView'
import SceneEdit from '../views/projectManage/singleProject/sceneManage/sceneEdit/SceneEdit'
import SingleProjectShare from '../views/projectManage/singleProject/SingleProjectShare'
import ProjectSummary from '../views/projectManage/singleProject/ProjectSummary'
import SharedSceneList from '../views/projectManage/singleProject/SharedSceneList'
import TeamManage from '../views/systemManage/teamManage/TeamManage'
import UserManage from '../views/systemManage/userManage/UserManage'
import RoleManage from '../views/systemManage/roleManage/RoleManage'
import PermissionManage from '../views/systemManage/permissionManage/PermissionManage'
import ProjMemberManage from '../views/systemManage/projMemberManage/ProjMemberManage'
import Login from '../views/Login'
import PrivateLogin from '../views/PrivateLogin'
import SceneShareView from '../views/projectManage/shareView/SceneShareView';
import DataSetShareView from '../views/projectManage/shareView/DataSetShareView';
import ServiceConfig from '../views/systemManage/ServiceConfig';
import UserCenter from '../views/UserCenter';
import DownloadCenter from '../views/DownloadCenter';
import SassConfig from '../views/systemManage/SassConfig';
import PrivateConfig from '../views/systemManage/PrivateConfig';
import ClientAuth from '../views/systemManage/ClientAuth';
import DataMigration from '../views/systemManage/dataMigration/DataMigration';
import OfflineDataZip from '../views/offlineDataZip/OfflineDataZip';
import MyShare from '../views/shareManage/MyShare';
import OtherShare from '../views/shareManage/OtherShare';
import PublicElement from '../views/elementManage/PublicElement.vue';
import PrivateElement from '../views/elementManage/PrivateElement.vue';
import ElementView from '../views/elementManage/ElementView.vue';
import NotFound from '../views/NotFound';
import ExceptionStatistics from '../views/dataStatistics/ExceptionStatistics'
import DownloadStatistics from '../views/dataStatistics/DownloadStatistics'
import APIUsage from '../views/dataStatistics/APIUsage'
import DataDictionary from '../views/projectManage/singleProject/dataDictionary/DataDictionary'
import { isMicroAppMode } from '@/microAdapt/utils'
Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const _createRouter = ({ base }) => {
    const _router = [{
        path: '/index',
        component: Index,
        redirect: '/projectList',
        children: [{
            path: '/projectList',
            component: ProjectList
        }, {
            path: '/apiUsage',
            component: APIUsage
        }, {
            path: '/exceptionStatistics',
            component: ExceptionStatistics
        }, {
            path: '/downloadStatistics',
            component: DownloadStatistics
        }, {
            path: '/teamManage',
            component: TeamManage
        },
        {
            path: '/projMemberManage',
            component: ProjMemberManage
        },
        {
            path: '/userManage',
            component: UserManage
        },
        {
            path: '/roleManage',
            component: RoleManage
        }, {
            path: '/permissionManage',
            component: PermissionManage
        }, {
            path: '/serviceConfig',
            component: ServiceConfig
        }, {
            path: '/clientAuth',
            component: ClientAuth
        }, {
            path: '/sassConfig',
            component: SassConfig
        }, {
            path: '/privateConfig',
            component: PrivateConfig
        }, {
            path: '/dataMigration',
            component: DataMigration
        }, {
            path: '/offlineDataZip',
            component: OfflineDataZip
        },
        {
            path: '/userCenter',
            component: UserCenter
        }, {
            path: '/downloadCenter',
            component: DownloadCenter
        },
        {
            path: '/myShare',
            component: MyShare
        }, {
            path: '/othersShare',
            component: OtherShare
        }, {
            path: '/publicElement',
            component: PublicElement
        },
        {
            path: '/privateElement',
            component: PrivateElement
        },
        {
            path: '/orderDetail',
            component: () => import('@/views/packageCenter/orderDetail.vue')
        },
        {
            path: '/paymentPackage',
            component: () => import('@/views/packageCenter/paymentPackage.vue')
        },
        {
            path: '/authorizationPackage',
            component: () => import('@/views/packageCenter/authorization/authorizationPackage.vue')
        },
        {
            path: '/purchasePackage',
            component: () => import('@/views/packageCenter/purchasePackage/index.vue')
        },
        ]
    }, {
        path: '/singleProject',
        component: SingleIndex,
        children: [{
            path: '/singleProject/dataDictionary/:projId/:projName',
            component: DataDictionary
        }, {
            path: '/singleProject/projManager/:projId/:projName',
            component: ProjManager
        },
        {
            path: '/singleProject/basicInfo/:projId/:projName',
            component: BasicInfo
        }, {
            path: '/singleProject/dataManage/:projId/:projName',
            component: DataManage
        }, {
            path: '/singleProject/dataManage/:projId',
            component: DataManage
        }, {
            path: '/singleProject/datasetView/:projId/:projName',
            component: DatasetView
        }, {
            path: '/singleProject/sceneList/:projId/:projName',
            component: SceneManage
        },
        {
            path: '/singleProject/panoramicDisplay/:projId/:projName',
            component: () => import('@/views/panoramicDisplay/index.vue')
        }, {
            path: '/singleProject/sceneView/:projId/:projName',
            component: SceneView
        }, {
            path: '/singleProject/sceneEdit/:projId/:projName',
            component: SceneEdit
        }, {
            path: '/singleProject/myShare/:projId/:projName',
            component: SingleProjectShare
        }, {
            path: '/singleProject/projectSummary/:projId/:projName',
            component: ProjectSummary
        }, {
            path: '/singleProject/sharedSceneList/:projId/:projName',
            component: SharedSceneList
        }, {
            path: '/singleProject/sharedSceneList/:projId',
            component: SharedSceneList
        }, {
            path: '/singleProject/versionView',
            component: VersionView
        }, {
            path: '/singleProject/versionCompare',
            component: VersionCompare
        },
        ]
    }, {
        path: '/login',
        component: Login
    }, {
        path: '/privateLogin',
        component: PrivateLogin
    }, {
        path: '/sceneShare/view/:shareId/:resourceId',
        component: SceneShareView
    }, {
        path: '/dataSetShare/view/:shareId/:resourceId',
        component: DataSetShareView
    }, {
        path: '/elementView',
        component: ElementView
    }, {
        path: '/supermap/sceneView',
        component: SceneView
    }, {
        path: '/supermap/privateElement',
        component: PrivateElement
    }, {
        path: '/supermap/sceneEdit/:projId/:projName',
        component: SceneEdit
    }, {
        path: '/supermap/elementView',
        component: ElementView
    }, {
        path: '/attachmentView',
        component: AttachmentView
    },]

    // 微前端模式下，不需要重定向
    if (!isMicroAppMode()) {
        _router.push({
            path: '/',
            redirect: '/projectList'
        })
        _router.push({
            path: '*',
            component: NotFound,
        })
    }
    return new Router({
        routes: _router,
        base: base ? base : '/'
    });
}

export let router = null

export const destoryRouter = () => {
    router = null
}

export const createRouter = (option) => {
    router = _createRouter(option)
}